/** @file Validates a skinned mesh's bind poses and weight bones, reporting document-rooted error paths. */
import type { MeshAtt } from '@pose2d/format/types';
import { inverseBindPoses } from './inverseBindPoses';
import { requireCompiledIndex } from './requireCompiledIndex';

/**
 * No-op for rigid meshes. Otherwise VALIDATION at `attachments.<id>.geometry.bindPose[.<bone>]`, then NOT_FOUND at
 * `attachments.<id>.geometry.weights.<v>`: the defects compileSkinning would hit, at paths into the document.
 */
export function checkSkinnedMesh(mesh: MeshAtt, id: string, boneIndex: ReadonlyMap<string, number>): void {
  const g = mesh.geometry;
  if (g.kind === 'rigid') return;
  const path = `attachments.${id}.geometry`;
  inverseBindPoses(mesh, path);
  g.weights.forEach((influences, v) => {
    for (const [bone] of influences) requireCompiledIndex(boneIndex, bone, 'bone', `${path}.weights.${v}`);
  });
}
